import styled from "styled-components";

import { colors } from "../../../../../consts";

import {
  Paragraph2,
  SmallButton,
  SmallButtonStyled,
  TextButton,
  WrapperContainer
} from "../../../../../components";
import { DateInputContainer } from "../../../../../components/DateInput/styled";
import {
  FirmwareInputVersionWrapper,
  FirmwareVersionInputContainer
} from "../../../../../components/FirmwareVersionInput/styled";

export const SectionTitle = styled(Paragraph2)`
  font-weight: 600;
`;

export const FormWrapperContainer = styled(WrapperContainer)`
  padding-right: 4px;
  padding-bottom: 16px;
`;

export const InputSectionWrapper = styled(WrapperContainer)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;

  ${DateInputContainer} {
    max-width: 100%;

    .react-datepicker-wrapper {
      width: 100%;
    }
  }

  ${FirmwareVersionInputContainer} {
    width: 100%;

    ${FirmwareInputVersionWrapper} {
      width: 100%;
    }
  }
`;

export const HardResetButton = styled(TextButton)`
  svg {
    path {
      transition: 0.5s fill;
    }
  }

  &:disabled {
    svg {
      path {
        fill: ${colors.RAISIN_50};
      }
    }
  }
`;

export const RemoveButton = styled(SmallButtonStyled)`
  color: ${colors.ERROR};
  white-space: nowrap;
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  ${SmallButton} {
    min-width: 140px;
  }
`;

export const InfoText = styled(Paragraph2)`
  font-size: 14px;
  font-weight: 500;

  span {
    color: ${colors.ERROR};
  }
`;
